import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SurveyService } from '../../../service/survey.service';
import { MessageService } from 'src/app/service/message.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SurveyNewNeedsRequest } from 'src/app/model/survey-request';
import { SurveyNeedsFisResponse } from 'src/app/model/survey-response';
import { SurveyNeedsEmit } from 'src/app/model/survey-emits';

@Component({
  selector: 'needs-fis',
  templateUrl: './needs-fis.component.html'
})
export class NeedsFisComponent implements OnChanges {
  @Input() surveyId!: string;
  @Input() needs?: SurveyNeedsFisResponse;
  @Output() complete = new EventEmitter<SurveyNeedsEmit>();

  needsForm!: FormGroup;

  completed: boolean = false;
  loading: boolean = false;

  constructor(
    private surveyService: SurveyService,
    private messageService: MessageService
  ) {}
    
  ngOnChanges(changes: SimpleChanges): void {
    // Check if the surveyId (new survey) or needs (show survey) inputs have changed
    if((changes['surveyId'] && changes['surveyId'].firstChange) || changes['needs']) {
      this.init();
    }
  }

  init(): void {
    this.needsForm = new FormGroup({
      protection: new FormControl(this.needs?.protection ?? false),
      savings: new FormControl(this.needs?.savings ?? false),
      savingsInvestment: new FormControl(this.needs?.savingsInvestment ?? false),
      savingsPlan: new FormControl(this.needs?.savingsPlan ?? false),
      previdence: new FormControl(this.needs?.previdence ?? false)
    });

    if(!this.isInsert()) {
      this.completed = true;
      this.needsForm.disable();
    }
  }

  isInsert(): boolean {
    return this.needs === undefined;
  }  

  get protection() { return this.needsForm.get('protection'); }
  get savings() { return this.needsForm.get('savings'); }
  get savingsInvestment() { return this.needsForm.get('savingsInvestment'); }
  get savingsPlan() { return this.needsForm.get('savingsPlan'); }
  get previdence() { return this.needsForm.get('previdence'); }

  onSavingsChange(event: MatCheckboxChange) {
    if(!event.checked) {
      this.needsForm.patchValue({
        savingsInvestment: false,
        savingsPlan: false
      });
    }
  }

  onSubmit() {
    if(this.completed) {
      return;
    }

    this.loading = true;
    this.completed = true;
    this.needsForm.disable();

    const payload: SurveyNewNeedsRequest = {
      protection: this.protection?.value,
      savings: this.savings?.value,
      savingsInvestment: this.savingsInvestment?.value,
      savingsPlan: this.savingsPlan?.value,
      previdence: this.previdence?.value
    }

    this.surveyService.insertNeedsFis(this.surveyId, payload).subscribe({
      next: () => {
        this.loading = false;
        this.complete.emit({
          previdence: this.previdence?.value,
          protection: this.protection?.value,
          savings: this.savings?.value,
          savingsInvestment: this.savingsInvestment?.value,
          savingsPlan: this.savingsPlan?.value
        });
      },
      error: () => {
        this.messageService.error('survey.new.message.unknown-error');

        this.loading = false;
        this.completed = false;
        this.needsForm.enable();
      }
    });
  }
}
